module.exports = __webpack_public_path__ + "static/media/troopr_guide_7.5fb14ebc.svg";